<template>
    <div id="app">
        <router-view v-if="isRouterAlive"></router-view>
    </div>
</template>
<style lang="scss">
//input框样式
.edit_common_form{
     // 设置输入框的宽度
    .el-form-item__content {
        width: 230px;
    }
    .el-range-editor--small.el-input__inner{
        width: 230px;
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner{
        width: 230px;
    }
    .el-select{
        width: 230px;
    }
    .el-textarea{
        width:600px;
    }
    .longWidth{
          .el-radio-group{
            width:500px
          }
          .el-radio{
              padding:8px 11px;
          }
          .el-input{
              width:210px
          }

          .el-checkbox-group{
               width: 500px;
          }
    }
    .commonWidth{
        width:560px;
        .el-form-item__content {
            width: 360px;
        }
        .el-input{
              width:230px
          }
    }
    .common_address_info{
            .el-form-item__content {
                width: 570px;
            }
            .el-select{
                // width:162px;
                width:185px;
            }
     }
    ._editor {
        width: 100%;
        .el-form-item__content {
        width: 100%;
        .document-editor {
            border: 1px solid #c4c4c4;
            .document-editor__toolbar {
                border: 0;
                border-bottom: 1px solid #c4c4c4;
                .ck-toolbar {
                    border: 0;
                }
            }
            .document-editor__editable {
            min-height: 400px;
            border: 0;
            }
        }
        }
    }

}
.cpmpany_list{
      .el-table__body, .el-table__footer, .el-table__header{
          width: 100%!important;
      }
      .el-table .cell.el-tooltip{
            width: 100%!important;
        }
        .el-table__empty-block{
            width: 100%!important;
        }
  }
  .scrollStyle{
    &::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 5px;
    }
    &::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 10px;
        background: rgba($color: #000000, $alpha: 0.3);
    }
    &::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        border-radius: 10px;
        background: rgba($color: #000000, $alpha: 0);
    }
  }
  .scrollDrawer {
    .el-drawer__body {
      overflow: auto;
    }

    .el-drawer__container ::-webkit-scrollbar {
      display: none;
    }
  }
  .cascaderClick{
    .el-cascader-panel{
        .el-checkbox {
            width: calc(100% - 20px);
            height: 100%;
            z-index: 10;
            position: absolute;
        }
        .el-radio{
          width: calc(100% - 20px);
          height: 100%;
          z-index: 10;
          position: absolute;
          top: 10px;
        }
        .el-radio__input{
          // visibility: hidden;  //隐藏单选框，不隐藏就不用设置
        }
        .el-cascader-node__postfix{
          top: 10px;
        }
    }
    .el-cascader-node__label{
        margin-left: 10px;
    }
  }
</style>
<script>
import { setWaterMark } from '@/common/watermark'
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },

  //销毁
  destroyed () {
       window.localStorage.removeItem('type');
  },
  mounted(){
      window.that = this
      // this.setWM()
  },
  methods: {
    // 设置水印
    setWM(){
      if(location.origin.indexOf('cn') == -1){
        setWaterMark('测试环境','jbbcs.hzjbqy.com')
      }
    },
    //刷新当前页面事件
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style>
    @import "../static/css/main.css";
    @import "../static/css/index.css";
    /* @import "../static/css/index.css"; */
    @import "../static/css/theme-green/color-green.css";
    /* @import '../static/css/theme-green/index.css'; */


    /* 让表格表头和内容对齐 */
    body .el-table th.gutter{
        display: table-cell!important;
    }
    body .el-table th {
        display: table-cell!important;
    }
    body .el-tooltip__popper{max-width:20%;line-height:20px;}
    /* .el-tooltip__popper,.el-tooltip__popper.is-dark{background:#f5f5f5 !important;
    color: #303133 !important;
    } */

 /* .el-table__body-wrapper{
    height: 549px!important;
} */

  /* 滚动条样式 */
  .test {
  overflow: auto;
  border  : none;
  }
  .test-1::-webkit-scrollbar {
  /*滚动条整体样式*/
  width : 10px;  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
  }
  .test-1::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #C1C1C1;
  }
  .test-1::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow : inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
  }
  .el-upload-list__item{
    transition: none !important
  }
  .el-dropdown-menu.el-popper{
    max-height: 400px;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue